var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{staticClass:"grid-action-menu-item",class:{ disabled: _vm.disabled},attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }